import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useWorkShiftStore, useForm } from "../../../../hooks";
import { InputForm, SelectForm, LoadingData, ErrorMessage } from "../../../ui";
import { useFormMessages } from "../../../hooks";

const formData = {
  doctorId: "",
  shiftType: "",
  date: "",
};

const formValidations = {
  doctorId: [(value) => value.length > 0, "Selecciona un doctor"],
  shiftType: [(value) => value.length > 0, "Selecciona una jornada"],
  date: [(value) => value.length > 0, "Selecciona una fecha"],
};

export const AddWorkShifModal = ({ isOpen, setIsOpen }) => {
  // Datos de hooks ----------------------------------------//
  const {
    // Props
    doctorsSelect,
    shiftTypes,
    message,
    isLoading,

    // Methods
    getDoctorsBySelect,
    startAddWorkShift,
  } = useWorkShiftStore();

  // States ------------------------------------------------//
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
    setValidateForm,
  });

  // Funciones ---------------------------------------------//
  const onSubmit = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startAddWorkShift(formState);
    }
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (doctorsSelect.data.length === 0 && isOpen) {
      getDoctorsBySelect();
    }
  }, [doctorsSelect.data, getDoctorsBySelect, isOpen]);

  useEffect(() => {
    if (!isOpen) {
      onResetForm();
      setValidateForm(false);
      setFormSubmitted(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (showSuccessMessage) {
      setIsOpen(false);
    }
  }, [showSuccessMessage]);

  return (
    <Modal
      show={isOpen}
      onHide={() => {
        setIsOpen(false);
      }}
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <h5 className="modal-title">Agregar Jornada</h5>
      </Modal.Header>
      <Modal.Body>
        <div className="row g-3">
          {/* Formulario estatico */}
          <>
            <div className="col-md-12">
              <SelectForm
                label={"Doctor"}
                sublabel={"Campo obligatorio"}
                options={doctorsSelect.data}
                labelKey={"name"}
                validation={formValidation.doctorIdValid}
                submit={validateForm}
                name={"doctorId"}
                value={formState.doctorId}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <SelectForm
                label={"Tipo de jornada"}
                sublabel={"Campo obligatorio"}
                options={shiftTypes}
                labelKey={"label"}
                validation={formValidation.shiftTypeValid}
                submit={validateForm}
                name={"shiftType"}
                value={formState.shiftType}
                onInputChange={onInputChange}
              />
            </div>
            <div className="col-md-12">
              <InputForm
                label={"Fecha"}
                sublabel={"Campo obligatorio"}
                type={"date"}
                placeholder={"Fecha"}
                validation={formValidation.dateValid}
                submit={validateForm}
                name={"date"}
                value={formState.date}
                onInputChange={onInputChange}
              />
            </div>
          </>

          {/* Mensajes */}
          <>
            {(isLoading || doctorsSelect.isLoading) && (
              <div className="col-md-12">
                <LoadingData />
              </div>
            )}
            {(showErrorMessage || doctorsSelect.message?.type === "error") && (
              <div className="col-md-12">
                <ErrorMessage>
                  {messageText || doctorsSelect.message.text}
                </ErrorMessage>
              </div>
            )}
          </>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => onSubmit()}
          disabled={isLoading}
        >
          Registrar
        </button>
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};
